import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import { Button, Card, Form, Alert } from 'react-bootstrap';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [alertMessage, setAlertMessage] = useState(null); // Mesaj için state
  const [isSuccess, setIsSuccess] = useState(false); // Başarılı mı başarısız mı kontrolü

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;

    // Şifre güncelleme isteğini gönder
    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: user.token,
          process: '100019454',
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
          confirmPassword: formData.confirmPassword
        }),
      });

      // HTTP yanıt kodunu kontrol et
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);

      if (data.success === true) {
        // Şifre başarıyla güncellendi
        setAlertMessage('Password has been successfully updated.');
        setIsSuccess(true);
      } else {
        // Hata durumu
        setAlertMessage('Failed to update password. Please try again.');
        setIsSuccess(false);
      }
    } catch (error) {
      // Hata oluştu
      console.error('An error occurred:', error);
      setAlertMessage('An error occurred while updating the password.');
      setIsSuccess(false);
    }
  };

  return (
    <Card className="mb-1 h-full">
      <Card.Body className="bg-light ">
        <div style={{ maxWidth: '400px', margin: '0 auto' }}>
          {alertMessage && (
            <Alert variant={isSuccess ? 'success' : 'danger'}>
              {alertMessage}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="oldPassword">
              <Form.Label>Old Password</Form.Label>
              <Form.Control
                type="password"
                value={formData.oldPassword}
                name="oldPassword"
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={formData.newPassword}
                name="newPassword"
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                value={formData.confirmPassword}
                name="confirmPassword"
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Button className="w-100" type="submit">
              Update Password
            </Button>
          </Form>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ChangePassword;
